import { BarChart } from '@mantine/charts';
import Colors from '../../constants/Colors';
import { Center, Stack, Text, Title } from '@mantine/core';
import { IconChartPieOff } from '@tabler/icons-react';

const AvgOrderValueChartComponent = ({ title, data, currency }) => {
  const hasData = data && Array.isArray(data) && data.length > 0;
  const chartHeight = 250;

  const noDataPlaceholder = (
    <Center h={chartHeight}>
      <Stack align="center" gap="xs">
        <IconChartPieOff size={48} color="var(--mantine-color-dimmed)" stroke={1.5} />
        <Text c="dimmed" size="sm">No Data</Text>
      </Stack>
    </Center>
  );

  // Transform data for bar chart: [{ id, label, value }] -> [{ name, value }]
  // Sort by value descending and take top 10
  const barData = hasData
    ? [...data]
        .filter((item) => item.value !== null && item.value !== undefined)
        .sort((a, b) => b.value - a.value)
        .slice(0, 10)
        .map((item, index) => ({
          name: item.label || item.id,
          value: item.value,
          color: Colors[index % Colors.length],
        }))
    : [];

  const valueFormatter = currency
    ? (value) => value.toLocaleString(navigator.language, { style: 'currency', currency })
    : (value) => value.toLocaleString(navigator.language);

  // Compact formatter for the y-axis ticks so wide currency labels (e.g.
  // "220 000 000,00 IDR") don't clip off the card or overlap the adjacent chart.
  // The full value is still shown in the tooltip via valueFormatter above.
  const axisFormatter = currency
    ? (value) =>
        value.toLocaleString(navigator.language, {
          style: 'currency',
          currency,
          notation: 'compact',
          maximumFractionDigits: 1,
        })
    : (value) =>
        value.toLocaleString(navigator.language, {
          notation: 'compact',
          maximumFractionDigits: 1,
        });

  const el = hasData && barData.length > 0 ? (
    <div style={{ minHeight: chartHeight, minWidth: 100 }}>
      <BarChart
        h={chartHeight}
        data={barData}
        dataKey="name"
        series={[{ name: 'value' }]}
        tickLine="y"
        gridAxis="y"
        withLegend={false}
        valueFormatter={valueFormatter}
        yAxisProps={{
          width: 'auto',
          tickFormatter: axisFormatter,
        }}
        xAxisProps={{
          angle: -45,
          textAnchor: 'end',
          height: 80,
        }}
        barProps={(item) => ({
          fill: item.color,
        })}
      />
    </div>
  ) : (
    noDataPlaceholder
  );

  return (
    <>
      <Title order={5}>{title}</Title>
      {el}
    </>
  );
};

export default AvgOrderValueChartComponent;
